import { render } from "./DiffDates.vue?vue&type=template&id=16be41a0&scoped=true"
import script from "./DiffDates.vue?vue&type=script&lang=js"
export * from "./DiffDates.vue?vue&type=script&lang=js"

import "./DiffDates.vue?vue&type=style&index=0&id=16be41a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16be41a0"]])

export default __exports__